import { Button } from "@mui/material";
import VpnKeyIcon from "@mui/icons-material/VpnKey";

interface ManageCredentialsChatButtonProps {
  isLoading: boolean;
  handleManageCredentials: () => void;
  visible: boolean;
}

export function ManageCredentialsChatButton(props: ManageCredentialsChatButtonProps) {
  const { handleManageCredentials, visible, isLoading } = props;

  if (!visible || isLoading) {
    return null;
  }

  return (
    <Button
      onClick={handleManageCredentials}
      variant={"outlined"}
      startIcon={<VpnKeyIcon />}
      sx={{
        border: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      View PCC status
    </Button>
  );
}
